"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("../");
class PipelineModel extends _1.BaseModel {
    get isBuyerRep() {
        return this.type && this.type.toLowerCase().includes('buyer');
    }
    get isLandlordRep() {
        return this.type && this.type.toLowerCase().includes('landlord');
    }
    get isSellerRep() {
        return this.type && this.type.toLowerCase().includes('seller');
    }
    get isTenantRep() {
        return this.type && this.type.toLowerCase().includes('tenant');
    }
    get isExternal() {
        return this.type && this.type.toLowerCase().includes('external');
    }
    transformFromSalesforce(sfObject) {
        super.transformFromSalesforce(sfObject);
        this.createdDate = sfObject.CreatedDate;
        this.lastModifiedDate = sfObject.SystemModstamp;
    }
}
PipelineModel.STAGES = {
    PURSUIT: 'Pursuit',
    SOURCING: 'Sourcing',
    NEGOTIATION: 'Negotiation',
    CONTRACT: 'Contract',
    CLOSED_DEAL: 'Closed Deal'
};
exports.PipelineModel = PipelineModel;
//# sourceMappingURL=pipeline.model.js.map